/* global toastr */
import { BaseAdminModelView } from '../model_view'
import { wrapView, request } from '../../smart_bps/lib/utils'
import { stateToProps } from '../../smart_bps/admin/base_view'
import { store } from '../../index'
import AttrInput from '../../smart_bps/lib/attr_input'
import { preloadFormChoices } from '../../lib/preloadFormChoices'
import { normalizeSubjectForFlow } from './fileAccessAdminShared'
import { StageAccessTable } from './StageAccessTable'
import { FileAccessPreview } from './FileAccessPreview'

const FILE_ACCESS_CHOICES = [
  'FileAccessProjectState',
  'DocumentTypeFlow',
  'Role',
]

class DocumentFileAccessRefAdminModelView extends BaseAdminModelView {
  constructor(props) {
    super(props)
    this.reloadChoices = this.reloadChoices.bind(this)
  }

  componentDidMount() {
    super.componentDidMount?.()
    this.reloadChoices()
  }

  reloadChoices() {
    preloadFormChoices(this.props.attrs, FILE_ACCESS_CHOICES)
  }
  renderContent() {
    return (
      <div className="row">
        <div className="col-12">{this.renderContentLeft()}</div>
      </div>
    )
  }

  renderContentRight() {
    return null
  }

  renderContentLeftAction() {
    const saving = Boolean(this.state.saving)
    return (
      <div className="card mb-3" key="actions">
        <div className="card-body p-2">
          <span
            className={`btn btn-outline-primary waves-effect p-2 me-2${saving ? ' disabled' : ''}`}
            style={saving ? { pointerEvents: 'none', opacity: 0.65 } : undefined}
            onClick={saving ? undefined : this.saveObject}
            aria-disabled={saving}
          >
            <span className="ti ti-xs ti-check me-1" />
            {saving ? 'Сохранение…' : 'Сохранить'}
          </span>
        </div>
      </div>
    )
  }

  renderContentLeft() {
    const view = this
    const data = this.state.form_data || {}
    const attrs = this.props.attrs || {}
    const form_access = this.state.form_access || {}
    const rows = Array.isArray(data.stage_access_links_lnk) ? data.stage_access_links_lnk : []
    const cardFlow = data.document_flow || null
    const documentFlowAttr = attrs.document_flow

    const onFlowChange = (_, value) => {
      const flow = value || null
      const nextRows = rows.map((row) => {
        const stage = (row || {}).stage
        if (!flow || !stage || String(stage).startsWith(`${flow}:`)) {
          const allowed = view.props.attrs?.stage_access_links_lnk?.flow_file_types?.[flow]
          const types = (row || {}).file_types_lnk || []
          if (!allowed || types.length === 0) {
            return row
          }
          const allowedSet = new Set(allowed.map((item) => (Array.isArray(item) ? item[0] : item?.value)))
          const nextTypes = types.filter((t) => allowedSet.has(t))
          return nextTypes.length === types.length ? row : { ...row, file_types_lnk: nextTypes }
        }
        return { ...row, stage: '', file_types_lnk: [] }
      }).map((row) => {
        const subject = normalizeSubjectForFlow((row || {}).subject, flow)
        return subject === (row || {}).subject ? row : { ...row, subject }
      })
      view.setState({
        form_data: {
          ...data,
          document_flow: flow,
          stage_access_links_lnk: nextRows,
        },
      })
    }

    return (
      <div>
        {this.renderContentLeftAction()}
        <div className="card mb-3 form-sm">
          <div className="card-body p-3">
            <h5 className="card-title">Основное</h5>
            {documentFlowAttr && form_access.document_flow && (
              <div className="mb-3">
                <AttrInput
                  data_type={documentFlowAttr.data_type}
                  choice_name={documentFlowAttr.choice_name}
                  widget={documentFlowAttr.widget}
                  choices={this.props.choices}
                  name="document_flow"
                  title={documentFlowAttr.title}
                  value={data.document_flow}
                  access={form_access.document_flow}
                  error={this.state.form_errors?.document_flow}
                  onChange={onFlowChange}
                />
              </div>
            )}
            <h6 className="mb-2">Права по этапам</h6>
            <StageAccessTable
              view={this}
              rows={rows}
              cardFlow={cardFlow}
              formAccess={form_access}
              formErrors={this.state.form_errors}
              readOnly={form_access.stage_access_links_lnk !== 'edit'}
            />
          </div>
        </div>
        <div className="card mb-3">
          <div className="card-body p-3">
            <FileAccessPreview
              rows={rows}
              cardFlow={cardFlow}
              choices={this.props.choices}
              attrs={attrs}
            />
          </div>
        </div>
      </div>
    )
  }

  saveObject() {
    if (this.state.saving) return
    const that = this
    this.setState({ saving: true }, () => {
      request({
        method: 'post',
        url: `/api/admin/${this.model_name}/${that.object_id}/update_object`,
        data: {
          new_data: that.state.form_data,
          old_data: that.state.form_data_initial,
        },
        success: (data) => {
          const finish = () => {
            store.dispatch({ type: 'admin_list_clean' })
            if (data.form_data) {
              that.reloadChoices()
              that.dataToState(data)
              toastr.success('Изменения сохранены')
            }
            if (data.errors) {
              that.setState({
                form_errors: Object.keys(data.errors).length > 0 ? data.errors : undefined,
              })
              toastr.warning('Изменения не были сохранены. Исправьте ошибки в форме', 'Внимание')
            }
          }
          that.setState({ saving: false }, finish)
        },
        error: () => {
          that.setState({ saving: false })
          toastr.error('Ошибка сохранения')
        },
      })
    })
  }
}

export default wrapView(DocumentFileAccessRefAdminModelView, stateToProps)
